<template>
    <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
        <base-header type="gradient-success" class="pb-2 pb-2 pt-2 pt-md-2">
            <div class="row">
                <div class="col-md-12">
                    <router-link to="/hex-to-bytes">
                        <button class="btn btn-sm btn-primary ml-2 mt-2">Hex to Bytes</button>
                    </router-link>
                    <router-link to="/bytes-to-hex">
                        <button class="btn btn-sm btn-primary ml-2 mt-2">Bytes to Hex</button>
                    </router-link>
                    <router-link to="/dec-to-hex">
                        <button class="btn btn-sm btn-primary ml-2 mt-2">Dec to Hex</button>
                    </router-link>
                    <router-link to="/hex-to-dec">
                        <button class="btn btn-sm btn-primary ml-2 mt-2">Hex to Dec</button>
                    </router-link>
                    <router-link to="/dec-to-oct">
                        <button class="btn btn-sm btn-primary ml-2 mt-2">Dec to Oct</button>
                    </router-link>
                    <router-link to="/dec-to-bin">
                        <button class="btn btn-sm btn-primary ml-2 mt-2">Dec to Bin</button>
                    </router-link>
                    <router-link to="/bin-to-dec">
                        <button class="btn btn-sm btn-primary ml-2 mt-2">Bin to Dec</button>
                    </router-link>
                    <router-link to="/sha1">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">SHA1</button>
                    </router-link>
                    <router-link to="/sha3">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">SHA3</button>
                    </router-link>
                    <router-link to="/sha224">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">SHA224</button>
                    </router-link>
                    <router-link to="/sha256">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">SHA256</button>
                    </router-link>
                    <router-link to="/sha384">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">SHA384</button>
                    </router-link>
                    <router-link to="/sha512">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">SHA512</button>
                    </router-link>
                    <router-link to="/md5">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">MD5</button>
                    </router-link>
                    <router-link to="/ripemd160">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">RIPEMD160</button>
                    </router-link>
                    <router-link to="/to-base64">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">In Base64</button>
                    </router-link>
                    <router-link to="/from-base64">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">Base64 Decode</button>
                    </router-link>
                    <router-link to="/text-to-base58">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">In Base58</button>
                    </router-link>
                    <router-link to="/base58-decoder">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">Base58 Decode</button>
                    </router-link>
                    <router-link to="/aes-encoder">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">AES Encrypt</button>
                    </router-link>
                    <router-link to="/aes-decoder">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">AES Decrypt</button>
                    </router-link>
                    <router-link to="/des-encrypt">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">DES Encrypt</button>
                    </router-link>
                    <router-link to="/des-decrypt">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">DES Decrypt</button>
                    </router-link>
                    <router-link to="/3des-encrypt">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">3DES Encrypt</button>
                    </router-link>
                    <router-link to="/3des-decrypt">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">3DES Decrypt</button>
                    </router-link>
                    <router-link to="/rabbit-encoder">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">Rabbit Encrypt</button>
                    </router-link>
                    <router-link to="/rabbit-decoder">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">Rabbit Decrypt</button>
                    </router-link>
                    <router-link to="/rc4-encrypt">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">RC4 Encrypt</button>
                    </router-link>
                    <router-link to="/rc4-decrypt">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">RC4 Decrypt</button>
                    </router-link>
                    <router-link to="/crc32">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">CRC32</button>
                    </router-link>
                    <router-link to="/sha256-file">
                        <button class="ml-2 btn btn-sm btn-primary mt-2">File SHA256</button>
                    </router-link>
                </div>
            </div>
        </base-header>
        <!--
        <side-bar
          :background-color="sidebarBackground"
          short-title="Hasher"
          title="Hasher"
        >
          <template slot="links">
            <sidebar-item
              :link="{
                name: 'Dashboard',
                icon: 'ni ni-tv-2 text-primary',
                path: '/dashboard'
              }"
            />

            <sidebar-item :link="{name: 'Icons', icon: 'ni ni-planet text-blue', path: '/icons'}"/>

          </template>
        </side-bar>
        -->
        <div class="main-content" :data="sidebarBackground">
            <!--<dashboard-navbar></dashboard-navbar>-->

            <div @click="toggleSidebar">
                <fade-transition :duration="200" origin="center top" mode="out-in">
                    <!-- your content here -->
                    <router-view></router-view>
                </fade-transition>
                <content-footer v-if="!$route.meta.hideFooter && !mobile"></content-footer>
            </div>
        </div>
    </div>
</template>
<script>
    //import DashboardNavbar from './DashboardNavbar.vue';
    import ContentFooter from './ContentFooter.vue';
    import {FadeTransition} from 'vue2-transitions';

    export default {
        components: {
            //DashboardNavbar,
            ContentFooter,
            FadeTransition
        },
        data() {
            return {
                mobile: false,
                sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
            };
        },
        methods: {
            toggleSidebar() {
                if (this.$sidebar.showSidebar) {
                    this.$sidebar.displaySidebar(false);
                }
            }
        },
        mounted: function () {
            if (screen.width < 700) {
                this.mobile = true;
            }
        },
    };
</script>
<style lang="scss">
</style>
